import { Service } from '../types/services';

export const services: Service[] = [
  {
    id: '1',
    title: 'Project Management',
    description: 'Comprehensive project management solutions for construction projects',
    thumbnailUrl: 'PortfolioCollectionThumbnails/ProjectManagement.png',
    modalImageUrl: 'PortfolioCollectionThumbnails/ProjectManagement2.png',
    category: 'Management',
    features: [
      'Real-time project tracking and monitoring',
      'Resource allocation and optimization',
      'Timeline management and scheduling',
      'Budget tracking and cost control',
      'Team collaboration tools'
    ]
  },
  {
    id: '2',
    title: 'Software Solutions',
    description: 'Custom tailored software development for construction industry',
    thumbnailUrl: 'PortfolioCollectionThumbnails/SoftwareSolutions.png',
    category: 'Technology',
    features: [
      'Custom software development',
      'System integration services',
      'Mobile app development',
      'Cloud solutions',
      'API development and integration'
    ]
  },
  {
    id: '3',
    title: 'Jobsite Tools',
    description: 'Advanced tools and equipment for modern construction sites',
    thumbnailUrl: 'PortfolioCollectionThumbnails/JobsiteTools.png',
    modalImageUrl: 'PortfolioCollectionThumbnails/JobsiteTools2.png',
    category: 'Equipment',
    features: [
      'Digital measurement tools',
      'Site monitoring equipment',
      'Safety equipment',
      'Productivity tracking tools',
      'Equipment maintenance services'
    ]
  },
  {
    id: '4',
    title: 'AI Integration',
    description: 'AI-powered solutions for modern construction',
    thumbnailUrl: 'PortfolioCollectionThumbnails/AI-Integration.png',
    category: 'Technology',
    features: [
      'Machine learning algorithms',
      'Predictive analytics',
      'Automated decision support',
      'Computer vision solutions',
      'Natural language processing'
    ]
  },
  {
    id: '5',
    title: 'Fleet Management',
    description: 'Comprehensive fleet management and optimization solutions',
    thumbnailUrl: 'PortfolioCollectionThumbnails/FleetManagement.png',
    modalImageUrl: 'PortfolioCollectionThumbnails/FleetManagement2.png',
    category: 'Management',
    features: [
      'Vehicle tracking and monitoring',
      'Maintenance scheduling',
      'Fuel efficiency optimization',
      'Driver safety programs',
      'Route optimization'
    ]
  },
  {
    id: '6',
    title: 'Data Analytics',
    description: 'Data-driven insights for construction operations',
    thumbnailUrl: 'PortfolioCollectionThumbnails/DataAnalytics.png',
    category: 'Technology',
    features: [
      'Performance metrics tracking',
      'Custom reporting solutions',
      'Business intelligence dashboards',
      'Data visualization tools',
      'Trend analysis and forecasting'
    ]
  },
  {
    id: '7',
    title: 'Safety & Compliance',
    description: 'Ensuring safety standards and regulatory compliance',
    thumbnailUrl: 'PortfolioCollectionThumbnails/SafetyCompliance.png',
    category: 'Safety',
    features: [
      'Safety protocol development',
      'Compliance monitoring',
      'Training programs',
      'Incident reporting system',
      'Risk assessment tools'
    ]
  }
]; 